// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yo3T","question":"styles_question__1TdGX","description":"styles_description__2wPv6"};